import React from "react";
import { onEnterOrSpaceKey } from "../Common/utils";
/**
 * Edit icon
 * @param {*} props
 * @returns
 */
function EditPen(props) {
  const { click, classes, imgsrc, imgclass } = props;
  return (
    <div className={classes}>
      <img
        src={imgsrc}
        alt="Edit"
        role="button"
        tabIndex={0}
        onClick={click}
        onKeyDown={onEnterOrSpaceKey(click)}
        className={imgclass}
      />
    </div>
  );
}

export default EditPen;
